import { features } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-7xl">
        <div className="text-center mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">
            核心特色
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            经典征途，热血重燃
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            传承经典国战玩法，融合创新系统机制，打造最热血的手游体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group p-6 rounded-2xl bg-background-100 hover:bg-background-200/70 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${feature.icon} text-xl text-primary-600 group-hover:text-background-50 transition-colors duration-300`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}